import { ToggleSelector } from '@/components/primitives/ToggleGroup';
import { useSeatSelection } from '@/hooks/useSeatSelection';
import { TransText } from '@/i18n/trans/text';
import { useMemo } from 'react';

export const FloorSelector = () => {
  const { selectedFloorIndex, setSelectedFloorIndex, currentPlaceMap } =
    useSeatSelection();
  const floors = currentPlaceMap?.floors ?? [];
  const totalFloors = floors.length;
  const options = useMemo(
    () =>
      Array.from({ length: totalFloors }).map((_, index) => ({
        value: index.toString(),
        label: <TransText i18nKey="deckIndex" values={{ index: index + 1 }} />,
      })),
    [totalFloors]
  );

  if (totalFloors <= 1) {
    return null;
  }

  return (
    <ToggleSelector
      className="self-center"
      options={options}
      value={selectedFloorIndex?.toString()}
      onChange={(value) => setSelectedFloorIndex(Number(value))}
      data-testid="floor-selector"
    />
  );
};
